/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Sensor_Soil_TemperatureInputs */

const vi_irrigation_sensor_soil_temperature = /** @type {(inputs: Irrigation_Sensor_Soil_TemperatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhiệt độ`)
};

/**

* @param {Irrigation_Sensor_Soil_TemperatureInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_sensor_soil_temperature = /** @type {((inputs?: Irrigation_Sensor_Soil_TemperatureInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Sensor_Soil_TemperatureInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_sensor_soil_temperature(inputs)
});